class ManufacturersPage {
    constructor() {
        this.alltypes = document.querySelector(".qc-widget.alltypes");
        this.initDeviceTypeFilter();
    }
    initDeviceTypeFilter() {
        let items = this.alltypes?.querySelectorAll('.mdn-Radio');
        items?.forEach(elem => {
            elem.addEventListener("click", e => {
                i = this.alltypes?.querySelectorAll('.mdn-Radio');
                i.forEach(el => {
                    el.classList.remove("checked");
                    delete el.dataset.checked;
                })
                e.currentTarget.dataset.checked = "checked";
                e.currentTarget.classList.add("checked")
                this.filterDeviceType(e);
            });
        });

        let brands = document.querySelectorAll('.manufacturers.qc-widget .brand-card');
        brands.forEach(elem => {
            elem.addEventListener("click", e => {
                e.preventDefault();
                let selected = document.querySelector('.alltypes .mdn-Radio.checked');
                if (selected && selected.dataset.type!="all-types") {
                    window.location = e.currentTarget.href + `/${selected.dataset.type}`;

                } else {
                    window.location = e.currentTarget.href;
                }

            })
        });        
    }

    filterDeviceType(e) {
        let content = document.querySelector(".qc-widget.manufacturers .card-list");
        let brands = document.querySelectorAll('.manufacturers.qc-widget .brand-card');
        let devicetype = e.currentTarget.dataset.type;
        let sortable = [];



        brands.forEach(elem => {
            sortable.push(elem);
        });
        if (e.currentTarget.dataset.type == "all-types") {
            brands.forEach(el => {
                el.classList.remove("not-selected");
                try {
                    el.querySelector(".device-count .numeral").innerText = el.dataset.deviceNumber;
                } catch (error) { }
                el.href = QelpCareHUB.root + el.dataset.route + "/" + el.dataset.manufacturer;                
            });
        } else {

            eHelpFramework.call(`manufacturers/type/${devicetype}`, response => {
                // console.log(response, wrapper);
                brands.forEach(el => {
                    el.classList.add("not-selected");
                    try {
                        el.querySelector(".device-count .numeral").innerText = el.dataset.deviceNumber;
                    } catch (error) {}

                    el.href = QelpCareHUB.root + el.dataset.route + "/" + el.dataset.manufacturer + "/" + devicetype;
                });
                response.forEach(item => {
                    let card = document.querySelector(`.manufacturers.qc-widget .brand-card.${item.path}`);
                    card.classList.remove('not-selected');
                    try {
                        card.querySelector(".device-count .numeral").innerText = item.deviceNumber;
                    } catch (error) {}
                });
                sortable.sort((a, b) => {
                    return a.classList.contains("not-selected") < b.classList.contains("not-selected") ? -1 : 1;
                });
                let i = 0;
                sortable.forEach(elem => {
                    i++;
                    let t = (i * 30);
                    elem.style.order = i;
                    elem.classList.add("vanish");
                    elem.style.transitionDelay = t + "ms";
                    content.append(elem);
                    setTimeout(() => {
                        elem.classList.remove("vanish");
                    }, 100);
                });
                
            }, "GET");
        }
    }
}
window.addEventListener("eHelpFrameworkReady", e => {
    eHelpFramework.pages.push(new ManufacturersPage())
});